import React from "react";

export default function ErrorMessage({ errorMessage }) {
  return errorMessage ? (
    <div className="alert alert-danger" role="alert">
      <p>There was an error:</p>
      <p>{errorMessage}</p>
    </div>
  ) : null;
}
